import { render, staticRenderFns } from "./NewRegistration.vue?vue&type=template&id=3d80d1d1&scoped=true&"
import script from "./NewRegistration.vue?vue&type=script&lang=js&"
export * from "./NewRegistration.vue?vue&type=script&lang=js&"
import style0 from "./NewRegistration.vue?vue&type=style&index=0&id=3d80d1d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80d1d1",
  null
  
)

export default component.exports